module.exports = __webpack_public_path__ + "static/media/git.1190a19c.svg";